export enum ActivePage {
    DASHBOARD = "Dashboard",
    ANALYTICS = "Analytics",
    SETTINGS = "Settings"
}
